import { Controller } from "@hotwired/stimulus"

// All Phases board — a card dropped into a secondary-phase column that
// belongs to ANOTHER primary phase (Phelipe 2026-09-03). A primary-phase
// change has layers the board can't do justice to yet (winner, dates,
// payment, documents), so for now the popup explains what's about to
// happen and takes the person to the project's settings page, landing on
// the phase-change card. Running the full flow inside this popup is the
// next step, later. The dropped-on card snaps back meanwhile.
// Construction → Design (2026-10-29) is the one move the popup runs
// itself: it takes the contractors off the team, so it asks once and
// "Move back" hands it back to the board (`run` in the event).
export default class extends Controller {
  static targets = ["modal", "title", "intro", "detail", "goBtn", "runBtn"]

  open(event) {
    const d = event.detail
    if (!d || !d.projectId) return
    this._move = d
    const name = d.projectName || "this project"
    const from = this._label(d.fromPrimary), to = this._label(d.toPrimary)
    const runHere = typeof d.run === "function"

    if (runHere) {
      this.titleTarget.textContent = `Move ${name} back to ${to}?`
      const sameAs = d.toPrimary === "dev" ? `, the same as "Send Back To ${to}" in the project's settings` : ""
      this.introTarget.textContent = `Its contractors and their people will be taken off the project team${sameAs}.`
      this.detailTarget.textContent = `It will show under "${d.stepName}".`
    } else {
      this.titleTarget.textContent = `Move ${name} to ${to}?`
      this.introTarget.textContent = `"${d.stepName}" is a step inside ${to}, and ${name} is in ${from}. Changing a project's primary phase is done from its settings page, where the full flow lives.`
      this.detailTarget.textContent = `Once it is in ${to}, it will show under the first step of that phase; you can then drag it to "${d.stepName}".`
    }
    this.goBtnTarget.classList.toggle("hidden", runHere)
    this.runBtnTarget.classList.toggle("hidden", !runHere)
    this.modalTarget.classList.remove("hidden")
  }

  run() {
    const d = this._move
    this.close()
    d?.run?.()
  }

  // Straight to the Administration card at the bottom of the project page.
  go() {
    const d = this._move
    if (!d) return
    window.location.assign(`/projects/${d.projectId}#phase-change`)
  }

  close() { this.modalTarget.classList.add("hidden") }
  stopPropagation(event) { event.stopPropagation() }

  _label(phase) {
    const labels = { real_estate: "Real Estate", dev: "Design", bidding: "Bidding", construction: "Construction", operations: "Operations" }
    return labels[phase] || phase
  }
}
